@if (schema()) {
  <mobi-ld-schema [schema]="schema()" />
}
<mobi-product-hero
  [headerImage]="entity().headerImage"
  [headerImageMobile]="entity().headerImageMobile"
  [title]="entity().title"
  [subtitle]="entity().subtitle"
  [superTitle]="entity().superTitle"
  [lead]="entity().lead"
  [rating]="entity().showProductRating && rating().count > 0 ? rating() : undefined"
  [hasOverview]="hasOverview()"
  [overviewCta1]="entity().overviewCta1"
  [overviewCta2]="entity().overviewCta2"
  [contentLinks]="contentLinks()"
  [calculatorCta]="entity().calculatorCta | calcCta: entity().calculatorCtaAuth"
  [consultationCta]="entity().consultationCta"
  [consultationCtaTitle]="entity().consultationCtaTitle"
  [calculatorCtaTitle]="entity().calculatorCtaTitle"
  [isProtektaProduct]="isProtektaProduct()"
  [calculatorCtaPrer]="calculatorCtaPrer()"
  [nodeId]="entity().id"
></mobi-product-hero>

<div class="page-content">
  <!-- The in-short host uses display: contents, a viewport trigger would never fire -->
  @defer (hydrate on idle) {
    @if (entity().inShortTitle) {
      <mobi-product-in-short
        class="mobi-ui-ink-blue"
        [hideRelation]="!!entity().furtherProducts?.length || false"
        [productTitle]="entity().productTitle || entity().title"
        [inShortText]="entity().inShortText"
        [inShortTitle]="entity().inShortTitle!"
        [inShortSubtitle]="entity().inShortSubtitle"
        [advantages]="entity().advantages"
        [productAward]="entity().productAward"
        [comboProduct]="entity().comboProduct ? entity().comboProduct : entity().product"
        [products]="entity().products"
        [productsTitle]="entity().productsTitle"
        [video]="entity().video"
      ></mobi-product-in-short>
    }
  }
  @if (entity().damageExamples || entity().faqs) {
    <div class="is-background mobi-ui-margin-y-xxl">
      @defer (hydrate on viewport) {
        @if (entity().damageExamples && entity().damageExamples!.length) {
          <mobi-product-damage-examples
            [title]="entity().damageTitle || ''"
            [damageExamples]="entity().damageExamples!"
            [damageExampleCta]="entity().damageExampleCta"
            [calcUrl]="entity().calculatorCtaAuth | extractUrl"
          ></mobi-product-damage-examples>
        }
      }
      @defer (hydrate on viewport) {
        @if (entity().packages && entity().packages!.packages.length) {
          <mobi-paragraph-pg-pps [paragraph]="entity().packages!" />
        }
        @if (
          (entity().faqs && entity().faqTitle && entity().faqs!.length > 0) ||
          (entity().covers && entity().covers!.length)
        ) {
          <mobi-product-faq
            [faqs]="entity().faqs"
            [faqTitle]="entity().faqTitle"
            [faqText]="entity().faqText"
            [covers]="entity().covers"
          ></mobi-product-faq>
        }
      }
    </div>
  }

  @defer (hydrate on viewport) {
    @if (entity().additionalSegmentTitle && entity().additionalSegmentTeaser) {
      <mobi-product-additional-segment
        class="mobi-ui-ink-blue"
        [additionalSegmentTeaser]="entity().additionalSegmentTeaser!"
        [additionalSegmentTitle]="entity().additionalSegmentTitle!"
        [additionalSegmentText]="entity().additionalSegmentText"
      ></mobi-product-additional-segment>
    }
  }
  @if (entity().promotedContent && entity().promotedContent!.length > 0) {
    @defer (hydrate on viewport) {
      <div class="mobi-ui-padding-y-xxl">
        <mobi-recommendations
          [id]="
            'promoted_content_paramenter_name'
              | texts: { context: 'frontend', default: 'Weitere Vorteile' }
              | anchorFormatter
          "
          class="block mobi-ui-ink-blue"
          [title]="entity().promotedContentTitle"
          [description]="entity().promotedContentText || ''"
          [recommendations]="entity().promotedContent!"
        ></mobi-recommendations>
      </div>
    }
  }
  @defer (hydrate on viewport) {
    @if (entity().usp) {
      <mobi-product-usp
        [uspTitle]="entity().uspTitle"
        [uspText]="entity().uspText"
        [usp]="entity().usp!"
      ></mobi-product-usp>
    }
  }

  @defer (hydrate on viewport) {
    @if (entity().furtherProducts && entity().furtherProducts!.length > 0) {
      <mobi-product-relation
        class="mobi-ui-ink-blue"
        [id]="
          'product_further_products_paramenter_name'
            | texts: { context: 'frontend', default: 'weitere-produkte' }
            | anchorFormatter
        "
        [products]="entity().furtherProducts!"
        [productTitle]="entity().title"
        [productsTitle]="entity().productsTitle"
        [ctaTitle]="entity().bundle === 'NodeProcov' ? entity().ctaTitle : undefined"
        [calculatorCta]="
          entity().bundle === 'NodeProcov'
            ? (entity().calculatorCta | calcCta: entity().calculatorCtaAuth)
            : undefined
        "
        [consultationCta]="
          entity().bundle === 'NodeProcov' ? entity().consultationCta : undefined
        "
        [consultationCtaTitle]="
          entity().bundle === 'NodeProcov' ? entity().consultationCtaTitle : undefined
        "
        [calculatorCtaTitle]="
          entity().bundle === 'NodeProcov' ? entity().calculatorCtaTitle : undefined
        "
        theme="light"
      />
    }
  }

  @if (isAssetManagement() && entity().paragraphs) {
    <div class="page-content mobi-ui-ink-blue">
      @for (paragraph of entity().paragraphs; track paragraph?.uuid ?? $index) {
        @if (paragraph) {
          <mobi-paragraph-loader
            [bundle]="paragraph.type"
            [data]="{ paragraph: paragraph }"
          />
        }
      }
    </div>
  }

  @defer (hydrate on viewport) {
    @if (entity().bundle !== 'NodeProcov') {
      <mobi-product-how-to-proceed
        [calculatorCtaTitle]="entity().calculatorCtaTitle"
        [calculatorCtaDescription]="entity().calculatorCtaDescription"
        [calculatorCta]="entity().calculatorCta | calcCta: entity().calculatorCtaAuth"
        [consultationCta]="entity().consultationCta"
        [consultationCtaTitle]="entity().consultationCtaTitle"
        [consultationCtaDescription]="entity().consultationCtaDescription"
        [calculatorCtaPrer]="calculatorCtaPrer()"
        [nodeId]="entity().id"
      />
    }
  }
</div>
